'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.currentlyEditingThisEditor = exports.startedEditingThisElement = exports.noLongerEditingThisEditor = exports.editingKeyNowEqualsThisKey = exports.editingKeyNoLongerEqualsThisKey = exports.editingKeyDoesNotEqualThisKey = exports.editingKeyEqualsThisKey = exports.editorStateHasChanged = exports.textContentHasChanged = exports.stayedEditingElement = exports.nowEditingElement = exports.noLongerEditingElement = undefined;

var _propsComparisons = require('../../../utils/react/propsComparisons');

// Property comparison functions
var noLongerEditingElement = exports.noLongerEditingElement = (0, _propsComparisons.noLonger)('isEditing'); // Utils
var nowEditingElement = exports.nowEditingElement = (0, _propsComparisons.now)('isEditing');
var stayedEditingElement = exports.stayedEditingElement = (0, _propsComparisons.stayedTrue)('isEditing');
var textContentHasChanged = exports.textContentHasChanged = (0, _propsComparisons.hasChanged)('textContent');
var editorStateHasChanged = exports.editorStateHasChanged = (0, _propsComparisons.hasChanged)('editorState');

var editingKeyEqualsThisKey = exports.editingKeyEqualsThisKey = function editingKeyEqualsThisKey(props) {
    return props.currentEditorKey === props.editorKey;
};
var editingKeyDoesNotEqualThisKey = exports.editingKeyDoesNotEqualThisKey = function editingKeyDoesNotEqualThisKey(props) {
    return props.currentEditorKey !== props.editorKey;
};
var editingKeyNoLongerEqualsThisKey = exports.editingKeyNoLongerEqualsThisKey = function editingKeyNoLongerEqualsThisKey(oldProps, newProps) {
    return editingKeyEqualsThisKey(oldProps) && editingKeyDoesNotEqualThisKey(newProps);
};
var editingKeyNowEqualsThisKey = exports.editingKeyNowEqualsThisKey = function editingKeyNowEqualsThisKey(oldProps, newProps) {
    return editingKeyDoesNotEqualThisKey(oldProps) && editingKeyEqualsThisKey(newProps);
};

var noLongerEditingThisEditor = exports.noLongerEditingThisEditor = function noLongerEditingThisEditor(oldProps, newProps) {
    return noLongerEditingElement(oldProps, newProps) && editingKeyEqualsThisKey(oldProps) || oldProps.isEditing && editingKeyNoLongerEqualsThisKey(oldProps, newProps);
};

var startedEditingThisElement = exports.startedEditingThisElement = function startedEditingThisElement(oldProps, newProps) {
    return nowEditingElement(oldProps, newProps) && editingKeyEqualsThisKey(newProps);
};

var currentlyEditingThisEditor = exports.currentlyEditingThisEditor = function currentlyEditingThisEditor(currentProps) {
    return currentProps.isEditing && editingKeyEqualsThisKey(currentProps);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/milanoteEditor/editorPropComparisons.js
// module id = 1717
// module chunks = 0